import { render, staticRenderFns } from "./HealthHistoryCN.vue?vue&type=template&id=0b96b6ac"
import script from "./HealthHistoryCN.vue?vue&type=script&lang=js"
export * from "./HealthHistoryCN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports